// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"e4528912","732":"d4032b56","977":"0c9e213d"}[chunkId] + ".chunk.js";
};